import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Signup from './components/UserManagement/Signup';
import Login from './components/UserManagement/Login';
import Dashboard from './components/UserManagement/Dashboard';
import Test from './components/Test/Test';
import authService from './services/auth';  // authService에서 isAuthenticated 사용
import ProtectedRoute from './components/UserManagement/ProtectedRoute';  // ProtectedRoute 컴포넌트 추가
import QuestCreate  from './components/Create_quest/Create_quest';
import Main from './components/Main/MainPage'; //메인 페이지 
import QuestPage from './components/Check_Quest/QuestPage'; // 퀘스트 페이지
import Mypage from './/components/UserManagement/Mypage' // 마이페이지
import ResetPWpage from './components/UserManagement/Reset_PW'; // 비밀번호 재설정
import Withdrawal from './components/UserManagement/Withdrawal'; // 비밀번호 재설정


//// 하단바
import NavBar from "./components/all_pages/Navbar";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('accessToken'));

  useEffect(() => {
    const checkLoginStatus = async () => {
      const token = localStorage.getItem('accessToken');
      // console.log("JWT 토큰:", token);  // 토큰 값이 제대로 저장되어 있는지 확인
      if (token) {
        const isAuthenticated = await authService.isAuthenticated();  // JWT 토큰 유효성 검사
        setIsLoggedIn(isAuthenticated);
      } else {
        setIsLoggedIn(false);
      }
    };
    checkLoginStatus();
  }, []);

  const handleLogin = (token) => {
    // console.log("로그인 시 저장된 토큰:", token);
    localStorage.setItem('accessToken', token);  // 로그인 시 토큰 저장
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    authService.logout();  // 로그아웃 시 토큰 삭제
    setIsLoggedIn(false);
  };

  return (
    <Router>
      <Routes>
        {/* 기본 경로: 로그인 여부에 따라 대시보드 또는 로그인 페이지로 이동 */}
        <Route path="/" element={<Navigate to={isLoggedIn ? "/mypage" : "/login"} />} />

        {/* 로그인 페이지 */}
        <Route path="/login" element={<Login setIsLoggedIn={handleLogin} />} />

        {/* 회원가입 페이지 */}
        <Route path="/register" element={<Signup />} />

        {/* 퀘스트 생성 페이지 */}
        <Route
          path="/create_quest"
          element={
            <ProtectedRoute>
              <QuestCreate />
            </ProtectedRoute>
          }
        />


        {/* 메인페이지 */}
        {/* <Route path="/Main" element={<Main />} /> */}
        <Route 
          path="/main" 
          element={
            <>
              <ProtectedRoute>
              <Main />   {/* 메인 페이지 내용 */}
              <NavBar defaultActive="calendar" />   {/* 네비게이션 바 */}
              </ProtectedRoute>
            </>
          }
        />



        {/* 퀘스트페이지 */}
        {/* <Route path="/QuestPage" element={<QuestPage />} /> */}
        <Route 
          path="/questpage" 
          element={
            <>
              <ProtectedRoute>
                <QuestPage />   {/* 메인 페이지 내용 */}
                <NavBar defaultActive="quest" />   {/* 네비게이션 바 */}
              </ProtectedRoute>
            </>
          }
        />

        {/* 대시보드 페이지: 로그인 여부 확인 후 접근 가능 */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />

        {/* 테스트 페이지: 로그인 여부 확인 후 접근 가능 */}
        <Route
          path="/test"
          // element={<Test />}
          element={
            <ProtectedRoute>
              <Test />
            </ProtectedRoute>
          }
        />


        {/* 마이페이지 : 로그인 여부 확인 후 접근 가능 */}
        <Route
          path="/mypage"
          element={
            <>
              <ProtectedRoute>
                <Mypage />   {/* 메인 페이지 내용 */}
                <NavBar defaultActive="mypage" />   {/* 네비게이션 바 */}
              </ProtectedRoute>
            </>
          }
        />

        {/* 비밀번호 재설정 : 로그인 여부 확인 후 접근 가능 */}
        <Route
          path="/ResetPW"
          element={
            <>
              <ProtectedRoute>
                <ResetPWpage />   {/* 비밀번호 재설정 내용 */}
              </ProtectedRoute>
            </>
          }
        />

        {/* 회원탈퇴 : 로그인 여부 확인 후 접근 가능 */}
        <Route
          path="/Withdrawal"
          element={
            <>
              <ProtectedRoute>
                <Withdrawal />   {/* 회원탈퇴 내용 */}
              </ProtectedRoute>
            </>
          }
        />




      </Routes>
    </Router>
  );
}

export default App;
